import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router";
import { ApiError } from "./api/client";
import { AppRoutes } from "./routes";
import { Toaster } from "./components/ui/toast";
import { Tooltips } from "./components/ui/Tooltips";
import { ReauthDialog } from "./auth/ReauthDialog";

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: false },
    },
  });
}

const queryClient = createQueryClient();

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRoutes />
        <ReauthDialog />
        <Toaster />
        <Tooltips />
      </BrowserRouter>
    </QueryClientProvider>
  );
}
